import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Philosophy() {
    const textRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {
            gsap.fromTo('.philosophy-line',
                { y: 50, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    stagger: 0.2,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: textRef.current,
                        start: 'top 80%',
                    }
                }
            );
        }, textRef);
        return () => ctx.revert();
    }, []);

    return (
        <section
            className="relative py-32 md:py-48 px-6 md:px-16 bg-dark overflow-hidden"
            id="philosophy"
        >
            {/* Parallaxing organic texture image matching 'dark grey laboratory glass tech' */}
            <div
                className="absolute inset-0 z-0 opacity-20 bg-fixed bg-cover bg-center mix-blend-screen"
                style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1542451313056-b7c8e626645f?q=80&w=2000&auto=format&fit=crop")' }}
            />
            <div className="absolute inset-0 z-0 bg-gradient-to-b from-dark via-transparent to-dark" />

            <div ref={textRef} className="relative z-10 max-w-5xl mx-auto flex flex-col items-center text-center">
                <p className="philosophy-line font-subheading text-xl md:text-2xl text-background/60 mb-8 max-w-2xl">
                    Most mobile agencies focus on: shipping generic hybrid templates that scale poorly and feel clunky.
                </p>

                <h2 className="philosophy-line font-heading font-bold text-4xl md:text-6xl lg:text-7xl tracking-tighter text-background leading-tight">
                    We focus on: <span className="font-drama text-accent block mt-2 text-6xl md:text-8xl lg:text-[8rem]">Engineering Instruments.</span>
                </h2>
            </div>
        </section>
    );
}
